import { Language } from '@/entities';

export const getPrimaryLanguage = (locale: string) => {
  return locale.split('-')[0].toLowerCase() as Language;
};
